/**
 * SEO HEADING STRUCTURE - Homepage (Index)
 * ========================================
 * 
 * TITLE: CSW - Online Workspace | Productivity Tool | Study Stream
 * META DESCRIPTION: Free virtual study rooms and online workspace for students...
 * 
 * H1: "Your Personal Productivity Tool & Online Workspace" (Hero component)
 * 
 * H2 tags are defined in child components (Modes, Impact, Features, StudyStream, CTA)
 */

import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Modes } from "@/components/Modes";
import { Impact } from "@/components/Impact";
import { Features } from "@/components/Features";
import { StudyStream } from "@/components/StudyStream";
import { CTA } from "@/components/CTA";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO 
        title="CSW - Online Workspace | Productivity Tool | Study Stream"
        description="Free virtual study rooms and online workspace for students. Join 24/7 study streams, use productivity tools, Pomodoro timer, and connect with learners worldwide."
        keywords="online workspace, virtual study room, study stream, productivity tool, pomodoro timer, study with me, online study room"
        canonicalUrl="/"
        isHomepage={true}
      />
      <Header />
      <main>
        <Hero />
        <Modes />
        <Impact />
        <Features />
        <StudyStream />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
